import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import Input from "./Input";
import Dropdown from "./Dropdown";
import Checkbox from "./Checkbox";
// import MyDropzone from "./MyDropzone";
import ModalComponent from "./Modal";
// import { randomString } from "../common";
import axios from 'axios'
import { toast } from "react-toastify";
import { setCurrenEoi } from "../redux/eoiReducer";
import { useDispatch } from "react-redux";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase-config";
import MyCalendar from "./Calendar";
import Radio from "./Radio";
import { trainers } from "../constants";
import TrainerFieldVerification from "./TrainerFieldVerification";
import { clearPageMessage, showLoadingMessage, showSuccessMessage, showWarningMessage } from "../successMessage";
import VerificationAuditLog from "./VerificationAuditLog";
import { buildUpdateAuditEvent, getVerificationActorName } from "../studentDetailVerification";
import AddressLookupModal from "./AddressLookupModal";

const DisplayTrafficEoi = ({ currentEoi, fetchEoi, isAdmin, userData, onCurrentEoiUpdated, onActionMessage, hideFooterActions = false }) => {

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
    const [showResidentialAddressLookup, setShowResidentialAddressLookup] = useState(false)
    const [showPostalAddressLookup, setShowPostalAddressLookup] = useState(false)

    // const [page, setPage] = useState(0)

    const [errors, setErrors] = useState([])
    const [errorMessage, setErrorMessage] = useState('')
    const [loading, setLoading] = useState(false)

    // Page = 0
    const [studentName, setStudentName] = useState('')
    const [trainingCourse, setTrainingCourse] = useState('')
    const [dateFirstPage, setDateFirstPage] = useState(new Date())
    const [trainerName, setTrainerName] = useState('') //Optional.

    const [iCan, setICan] = useState(['', '', '', '', '', '', '', '', '', '', ''])
    const iCanLabels = [
        'Write a SMS message',
        'Check change when shopping',
        'Read a TV guide',
        'Read an email',
        'Read a map',
        'Write a job application',
        'Calculate fractions, decimals and percentages',
        'Write a work report',
        'Read the prompts on an ATM',
        'Use a calculator',
        'Read an account or bill',
    ]

    const [alphabetWordOne, setAlphabetWordOne] = useState('')
    const [alphabetWordTwo, setAlphabetWordTwo] = useState('')
    const [alphabetWordThree, setAlphabetWordThree] = useState('')
    const [alphabetWordFour, setAlphabetWordFour] = useState('')
    const [alphabetWordFive, setAlphabetWordFive] = useState('')
    const [alphabetWordSix, setAlphabetWordSix] = useState('')

    const incorrectWords = ['Mondey', 'Bus', 'Pensil', 'Shoes', 'Food', 'Phone', 'Cleen', 'House', 'Play', 'Tecnical']
    const [chosenIncorrectWords, setChosenIncorrectWords] = useState([])
    const [whyInterested, setWhyInterested] = useState('')

    const [mathWordOne, setMathWordOne] = useState('')
    const [mathWordTwo, setMathWordTwo] = useState('')
    const [mathWordThree, setMathWordThree] = useState('')
    const [mathWordFour, setMathWordFour] = useState('')
    const [mathWordFive, setMathWordFive] = useState('')


    const [whyFollow, setWhyFollow] = useState('')
    const [familiarWith, setFamiliarWith] = useState('')
    const [vehicleExamples, setVehicleExamples] = useState('')
    const [oralDiscussion, setOralDiscussion] = useState('')


    const [chosenPrimaryDocument, setChosenPrimaryDocument] = useState('')


    const [title, setTitle] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [otherName, setOtherName] = useState('')

    const [streetNumber, setStreetNumber] = useState('')
    const [streetName, setStreetName] = useState('')
    const [suburb, setSuburb] = useState('')
    const [state, setState] = useState('')
    const [postcode, setPostcode] = useState('')
    const [address, setAddress] = useState('')

    const [postalAddressSame, setPostalAddressSame] = useState(false)
    const [addressPostal, setAddressPostal] = useState('')

    const [streetNumberPostal, setStreetNumberPostal] = useState('')
    const [streetNamePostal, setStreetNamePostal] = useState('')
    const [suburbPostal, setSuburbPostal] = useState('')
    const [statePostal, setStatePostal] = useState('')
    const [postcodePostal, setPostcodePostal] = useState('')


    const [dob, setDob] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [email, setEmail] = useState('')

    // School 
    const [passportNumber, setPassportNumber] = useState('')
    const [birthCertificate, setBirthCertificate] = useState('')
    const [birthStateIssue, setBirthStateIssue] = useState('')
    const [citizenCert, setCitizenCert] = useState('')
    const [ausLicense, setAusLicense] = useState('')
    const [ausLicenseStateIssue, setAusLicenseStateIssue] = useState('')

    // Overseas
    const [passportCountry, setPassportCountry] = useState('')

    // General
    const [boatLicense, setBoatLicense] = useState('')
    const [boatLicenseStateIssue, setBoatLicenseStateIssue] = useState('')

    const [nswPhotoLicense, setNswPhotoLicense] = useState('')
    const [highRiskLicense, setHighRiskLicense] = useState('')
    const [highRiskLicenseState, setHighRiskLicenseState] = useState('')

    const [proofAgeLicense, setProofAgeLicense] = useState('')
    const [proofAgeLicenseState, setProofAgeLicenseState] = useState('')
    const [policeCard, setPoliceCard] = useState('')

    const [pointsDocuments, setPointsDocuments] = useState([])
    // const [declareHundredPoints, setDeclareHundredPoints] = useState(false)


    const [declarationDate, setDeclarationDate] = useState(format(new Date(), 'dd-MM-yyyy'))
    const [trainerId, setTrainerId] = useState('')
    const [delivery, setDelivery] = useState('')

    // const signatureRef = useRef()

    // const navigate = useNavigate()
    const dispatch = useDispatch()


    const updateDropdownValue = val => ({ label: val, value: val })

    const handleDobChange = value => {
        const digits = value.replace(/\D/g, '').slice(0, 8)
        const formatted = digits.length > 4
            ? `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
            : digits.length > 2
                ? `${digits.slice(0, 2)}/${digits.slice(2)}`
                : digits
        setDob(formatted)
    }

    const evidenceOptions = ['Aboriginal and Torres Strait Islanders', 'School sector', 'Overseas persons recently arrived in Australia for less than 6 weeks.']

    const pointsDocumentOptions = ['Credit/Debit card/Statement (1)', 'Credit/Debit card/Statement (2)', 'Current Medicare card', 'Telephone Bill (issued in last 3 months)', 'Utility Bill (issued in last 3 months)', 'Current Centrelink card', 'Current Vehicle Registration', 'Property Lease Agreement', 'Motor Vehicle Insurance', 'Council Rates notice (issued in last 3 months)', 'Home Insurance papers', 'Dept Veterans Affairs card']


    useEffect(() => {
        if (currentEoi) {
            console.log('currentEoi', currentEoi.id)
            resetDoc()
        }
    }, [currentEoi])



    const resetDoc = () => {
        const data = currentEoi.data
        console.log(currentEoi.data.signature)
        // setUsi(data.usi)


        setTrainerId(data.trainerId)
        setDelivery(data.delivery)
        setStudentName(data.studentName)
        setTrainingCourse(data.trainingCourse)
        setDateFirstPage(new Date(data.dateFirstPage))
        const matchingTrainer = trainers.find(r => r.trainerId == data.trainerId)

        if (matchingTrainer) {
            setTrainerName(matchingTrainer.name)
        }

        console.log('data', data)
        setICan(data.iCan)

        setAlphabetWordOne(data.alphabetWords[0])
        setAlphabetWordTwo(data.alphabetWords[1])
        setAlphabetWordThree(data.alphabetWords[2])
        setAlphabetWordFour(data.alphabetWords[3])
        setAlphabetWordFive(data.alphabetWords[4])
        setAlphabetWordSix(data.alphabetWords[5])
        setChosenIncorrectWords(data.chosenIncorrectWords)
        setWhyInterested(data.whyInterested)

        setMathWordOne(data.mathWordOne)
        setMathWordTwo(data.mathWordTwo)
        setMathWordThree(data.mathWordThree)
        setMathWordFour(data.mathWordFour)
        setMathWordFive(data.mathWordFive)
        setWhyFollow(data.whyFollow)
        setFamiliarWith(data.familiarWith)
        setVehicleExamples(data.vehicleExamples)
        setOralDiscussion(data.oralDiscussion)


        // setChosenMethodFill(updateDropdownValue(data.chosenMethodFill))

        data.chosenPrimaryDocument && setChosenPrimaryDocument(updateDropdownValue(data.chosenPrimaryDocument))


        setTitle({ label: data.title, value: data.title })


        setFirstName(data.firstName)
        setLastName(data.lastName)
        setOtherName(data.otherName || '')
        setEmail(data.email)
        setPhoneNumber(data.phoneNumber)
        setDob(data.dob)
        setStreetNumber(data.streetNumber)
        setStreetName(data.streetName)
        setPostcode(data.postcode)
        setSuburb(data.suburb)
        setState(updateDropdownValue(data.state))
        setAddress(data.address || '')

        setPostalAddressSame(data.postalAddressSame)
        setAddressPostal(data.addressPostal || '')
        setStreetNumberPostal(data.streetNumberPostal || '')
        setStreetNamePostal(data.streetNamePostal || '')
        setPostcodePostal(data.postcodePostal || '')
        setSuburbPostal(data.suburbPostal || '')
        setStatePostal(updateDropdownValue(data.statePostal) || '')

        // setCountry(updateDropdownValue(data.country))
        // setOtherCountry(data.otherCountry)
        // setLanguage(updateDropdownValue(data.language))
        // setOtherLanguage(data.otherLanguage)
        // setOrigin(updateDropdownValue(data.origin))
        // setYearCompleted(updateDropdownValue(data.yearCompleted))
        // setPreviousQualification(updateDropdownValue(data.prevQualification))
        // setEmployment(updateDropdownValue(data.employment))
        // setDisabilities(data.disabilities && data.disabilities.map(v => updateDropdownValue(v)))


        // setEvidenceIdentity(updateDropdownValue(data.evidenceIdentity))
        // setPassportExpiry(data.passportExpiry)
        // setArrivalDate(data.arrivalDate)

        setPassportNumber(data.passportNumber || '')
        setPassportCountry(data.passportCountry || '')
        setBirthCertificate(data.birthCertificate || '')
        setBirthStateIssue(updateDropdownValue(data.birthStateIssue))
        setCitizenCert(data.citizenCert || '')
        setAusLicense(data.ausLicense || '')
        setAusLicenseStateIssue(updateDropdownValue(data.ausLicenseStateIssue))
        // setHasStudentIdWithCres(updateDropdownValue(data.hasStudentIdWithCres))


        setBoatLicense(data.boatLicense || '')
        setBoatLicenseStateIssue(updateDropdownValue(data.boatLicenseStateIssue))
        setNswPhotoLicense(data.nswPhotoLicense || '')
        setHighRiskLicense(data.highRiskLicense || '')
        setHighRiskLicenseState(updateDropdownValue(data.highRiskLicenseState))
        setProofAgeLicense(data.proofAgeLicense || '')
        setProofAgeLicenseState(updateDropdownValue(data.proofAgeLicenseState))
        setPoliceCard(data.policeCard || '')
        data.pointsDocuments && setPointsDocuments(data.pointsDocuments.map(v => updateDropdownValue(v)))

        // setDeclareHundredPoints(data.declareHundredPoints)
        // setDocument(data.document)

        setDeclarationDate(data.declarationDate)
    }


    const handleUpdate = async () => {
        showLoadingMessage('Updating EOI')
        const id = currentEoi.id

        try {
            setLoading(true)


            let additionalPayload = {}

            if (chosenPrimaryDocument && chosenPrimaryDocument.value === 'Birth Certificate') {
                additionalPayload = {
                    birthCertificate,
                    birthStateIssue: birthStateIssue.value,
                }
            } else if (chosenPrimaryDocument && chosenPrimaryDocument.value === 'Australian / International Passport') {
                additionalPayload = {
                    passportNumber,
                    passportCountry,
                }

            } else if (chosenPrimaryDocument && chosenPrimaryDocument.value === 'Australian Citizenship Certificate') {
                additionalPayload = { citizenCert }
            }

            additionalPayload = {
                chosenPrimaryDocument: chosenPrimaryDocument && chosenPrimaryDocument.value,
                ...additionalPayload,
                ausLicense,
                ausLicenseStateIssue: ausLicenseStateIssue && ausLicenseStateIssue.value,
                boatLicense,
                boatLicenseStateIssue: boatLicenseStateIssue && boatLicenseStateIssue.value,
                nswPhotoLicense,
                highRiskLicense,
                highRiskLicenseState: highRiskLicenseState.value,
                proofAgeLicense,
                proofAgeLicenseState: proofAgeLicenseState.value,
                policeCard,
                pointsDocuments: pointsDocuments.map(row => row.value),
            }

            const nextData = {
                ...currentEoi.data,
                trainerId: currentEoi.data.trainerId,
                id,
                studentName,
                trainingCourse,
                dateFirstPage,
                iCan,
                alphabetWords: [alphabetWordOne, alphabetWordTwo, alphabetWordThree, alphabetWordFour, alphabetWordFive, alphabetWordSix],
                chosenIncorrectWords,
                whyInterested,
                mathWordOne,
                mathWordTwo,
                mathWordThree,
                mathWordFour,
                mathWordFive,
                whyFollow,
                familiarWith,
                vehicleExamples,
                oralDiscussion,
                delivery,
                ...additionalPayload,
                title: title.value,
                firstName,
                lastName,
                otherName,
                email,
                phoneNumber,
                dob,
                streetNumber,
                streetName,
                postcode,
                suburb,
                state: state.value,
                address,
                postalAddressSame,
                addressPostal,
                streetNumberPostal,
                streetNamePostal,
                postcodePostal,
                suburbPostal,
                statePostal: statePostal.value,
                declarationDate,
                signature: currentEoi.data.signature
            }

            const updateAuditEvent = buildUpdateAuditEvent({
                previousData: currentEoi.data,
                nextData,
                actorName: getVerificationActorName(userData),
                actorId: userData?.id || userData?.trainerId || userData?.email || '',
            })

            if (updateAuditEvent) {
                nextData.changeAuditHistory = [
                    ...(currentEoi.data.changeAuditHistory || []),
                    updateAuditEvent,
                ]
            }

            const resp = await axios.post('https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/trafficEOI', {
                data: nextData
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                }
            })

            onCurrentEoiUpdated && onCurrentEoiUpdated({
                ...currentEoi,
                data: nextData,
                trainerId: currentEoi.data.trainerId,
                delivery,
                firstName,
                lastName,
                email,
                phoneNumber,
                dob,
                pdf: typeof resp.data === 'string' ? resp.data : currentEoi.pdf,
                updated: new Date().toISOString(),
            })
            setLoading(false)
            if (onActionMessage) {
                onActionMessage('EOI has been updated', true)
            }
            showSuccessMessage('EOI updated successfully')
            // window.open(resp.data)
        } catch (e) {
            setLoading(false)
            clearPageMessage()
            if (onActionMessage) {
                onActionMessage('Error occurred updating!', false)
            } else {
                toast.error('Error occurred updating!', { position: 'top-center' })
            }
            console.error('e', e)
        }

    }

    const handleTrainerVerificationUpdated = (nextEoi) => {
        onCurrentEoiUpdated && onCurrentEoiUpdated(nextEoi)
    }

    const applyResidentialAddressLookup = ({ address: nextAddress, streetNumber: nextStreetNumber, streetName: nextStreetName, suburb: nextSuburb, state: nextState, postcode: nextPostcode }) => {
        setAddress(nextAddress)
        setStreetNumber(nextStreetNumber)
        setStreetName(nextStreetName)
        setSuburb(nextSuburb)
        setState(updateDropdownValue(nextState))
        setPostcode(nextPostcode)
    }

    const applyPostalAddressLookup = ({ address: nextAddress, streetNumber: nextStreetNumber, streetName: nextStreetName, suburb: nextSuburb, state: nextState, postcode: nextPostcode }) => {
        setPostalAddressSame(false)
        setAddressPostal(nextAddress)
        setStreetNumberPostal(nextStreetNumber)
        setStreetNamePostal(nextStreetName)
        setSuburbPostal(nextSuburb)
        setStatePostal(updateDropdownValue(nextState))
        setPostcodePostal(nextPostcode)
    }

    const toggleIncorrectWords = (word, value) => {
        if (value && !chosenIncorrectWords.includes(word)) {
            setChosenIncorrectWords([...chosenIncorrectWords, word])
        } else {
            setChosenIncorrectWords(chosenIncorrectWords.filter(r => r !== word))
        }

    }

    if (!currentEoi) {
        return <></>
    }


    const handleDelete = async () => {
        showLoadingMessage('Deleting EOI')
        try {
            setLoading(true)
            await deleteDoc(doc(db, currentEoi.data.trainingType, showDeleteConfirmation))
            setShowDeleteConfirmation(false)
            dispatch(setCurrenEoi())
            fetchEoi()
            showSuccessMessage('EOI deleted successfully')
        } catch (error) {
            clearPageMessage()
            showWarningMessage('EOI could not be deleted. Please try again.')
        } finally {
            setLoading(false)
        }
    }

    return (<div className="contentBlock trafficEoiDisplay">

        <div className="formWrapperInContentBlock">
            <div className='trainerLlnAssessmentHeading'>Language, Literacy, Numeracy &amp; Digital Assessment</div>
            {!address && <p style={{ color: 'orange' }}>Manual Address entry!</p>}
            <div className="eoiPopupSummaryGrid" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', columnGap: '24px', alignItems: 'start' }}>
                <Input type={'text'} bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} errorMessage={errors.includes('studentName') && errors.length === 1 && errorMessage} errors={errors} name={'studentName'} value={studentName} setValue={setStudentName} label={'Student Name'} />
                <Input type={'text'} bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} errorMessage={errors.includes('trainingCourse') && errors.length === 1 && errorMessage} errors={errors} name={'trainingCourse'} value={trainingCourse} setValue={setTrainingCourse} label={'Training Course'} />
                <div>
                    <label style={{ display: 'flex', marginTop: '15px', fontWeight: '700', fontSize: '16px', color: '#000' }}>{'Date'}</label>
                    <MyCalendar startDate={dateFirstPage} setStartDate={setDateFirstPage} />
                </div>
                <Input type={'text'} bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} errorMessage={errors.includes('delivery') && errors.length === 1 && errorMessage} errors={errors} name={'delivery'} value={delivery} setValue={setDelivery} label={'Delivery'} />
            </div>
            <Input disabled type={'text'} bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} errorMessage={errors.includes('trainerName') && errors.length === 1 && errorMessage} errors={errors} name={'trainerName'} value={trainerName} setValue={setTrainerName} label={'Trainer Name'} />

            <p>This pre training language, literacy, numeracy &amp; digital assessment is carried out to assess your
                capabilities. As an RTO, we always try to deliver the highest standard of service, and to do this, we
                need to ensure you have the knowledge to complete this training course.</p>
            <p><b>Instructions:<br /></b>
                Complete the following exercises to the best of your ability. You should try to complete all tasks
                and take your time and read each question carefully.</p>
            <p><b>This evaluation is not a test<br /></b>
                The information you provide about your writing and math skills will help us plan support throughout
                the program. This information is confidential and will not be used for any other purpose and will
                remain the property of Upskill Institute.</p>
            <b className={`trainerLlnSkillsHeading ${errors.includes('iCan') ? 'error' : ''}`}>Tell us about your reading, writing and numeracy skills.</b>
            <table>
                <thead>
                    <tr>

                        <th>I can</th>
                        <th>Yes</th>
                        <th>Sometimes</th>
                        <th>No</th>
                    </tr>
                </thead>
                <tbody>
                    {iCanLabels.map((label, index) => <tr key={label}>
                        <td>{label}</td>
                        <td> <Radio checked={'Yes' === iCan[index]} label={'Yes'} setValue={v => setICan([...iCan.map((r, idx) => idx === index ? v : r)])} /></td>
                        <td> <Radio checked={'Sometimes' === iCan[index]} label={'Sometimes'} setValue={v => setICan([...iCan.map((r, idx) => idx === index ? v : r)])} /></td>
                        <td> <Radio checked={'No' === iCan[index]} label={'No'} setValue={v => setICan([...iCan.map((r, idx) => idx === index ? v : r)])} /></td>
                    </tr>)}
                </tbody>
            </table>
            <br />
            <b>1. Look at the group of words below. Arrange these words in alphabetical order</b>

            <p> sun - shop - stop - strong - some - spot</p>
            {/* {alphabetWords.map((word, index) =>
            <Input key={word + index} type={'text'} errors={[]} name={'alphabetWords'} value={word} setValue={v => setAlphabetWords(alphabetWords.map((r, idx) => idx === index ? v : r))} label={index + 1 + '.'} />
            )} */}

            <Input type={'text'} errors={errors} name={'alphabetWordOne'} value={alphabetWordOne} setValue={setAlphabetWordOne} label={1 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordTwo'} value={alphabetWordTwo} setValue={setAlphabetWordTwo} label={2 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordThree'} value={alphabetWordThree} setValue={setAlphabetWordThree} label={3 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordFour'} value={alphabetWordFour} setValue={setAlphabetWordFour} label={4 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordFive'} value={alphabetWordFive} setValue={setAlphabetWordFive} label={5 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordSix'} value={alphabetWordSix} setValue={setAlphabetWordSix} label={6 + '.'} />

            <br />
            <b className={errors.includes('chosenIncorrectWords') && 'error'}>2. Tick each incorrectly spelt words</b>
            <br />
            <br />
            <div className='checkboxGroup trainerLlnSpellingGrid'>
                {incorrectWords.map(word =>
                    <Checkbox key={word} label={word} value={chosenIncorrectWords.includes(word)} setValue={(v) => toggleIncorrectWords(word, v)} />
                )}
            </div>

            <br />
            <br />
            <b>3. Write a short paragraph about why you are interested in doing this course?</b>
            <br />
            <textarea className={errors.includes('whyInterested') && 'error'} onChange={e => setWhyInterested(e.target.value)} value={whyInterested}></textarea>


            <b>4. Answer the following calculations.</b>
            <div className='trainerLlnMathGrid'>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginTop: '40px' }}>a. 12 + 34 + 53 =</p>
                <Input type={'text'} errors={errors} name={'mathWordOne'} value={mathWordOne} setValue={setMathWordOne} label={''} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginTop: '40px' }}>b. 147 - 31 =</p>
                <Input type={'text'} errors={errors} name={'mathWordTwo'} value={mathWordTwo} setValue={setMathWordTwo} label={''} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginTop: '40px' }}>c. 11 x 8 =</p>
                <Input type={'text'} errors={errors} name={'mathWordThree'} value={mathWordThree} setValue={setMathWordThree} label={''} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginTop: '40px' }}>d. 100 ÷ 4 =</p>
                <Input type={'text'} errors={errors} name={'mathWordFour'} value={mathWordFour} setValue={setMathWordFour} label={''} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginTop: '40px' }}>e. $2.07 + $0.92 + $115.00 =</p>
                <Input type={'text'} errors={errors} name={'mathWordFive'} value={mathWordFive} setValue={setMathWordFive} label={''} />
            </div>
            </div>

            <br />
            <b>5. Why should you follow health and safety instructions?</b>
            <br />
            <textarea className={errors.includes('whyFollow') && 'error'} onChange={e => setWhyFollow(e.target.value)} value={whyFollow}></textarea>

            <br />
            <b>6. What types of traffic control equipment are you familiar with??</b>
            <br />
            <textarea className={errors.includes('familiarWith') && 'error'} onChange={e => setFamiliarWith(e.target.value)} value={familiarWith}></textarea>

            <br />
            <b>7. What are three vehicle type examples?</b>
            <br />
            <textarea className={errors.includes('vehicleExamples') && 'error'} onChange={e => setVehicleExamples(e.target.value)} value={vehicleExamples}></textarea>

            <br />
            <b>11. Oral Discussion</b>
            <p>Describe what you see in this picture below to your assessor. The Assessor will record your
                response below</p>
            <img src='https://upskillinstitute.com.au/wp-content/uploads/2021/03/Traffic-Oral.png' style={{ width: '100%' }} />
            <textarea className={errors.includes('oralDiscussion') && 'error'} onChange={e => setOralDiscussion(e.target.value)} value={oralDiscussion}></textarea>





            <hr style={{ border: 0, borderTop: '1px solid #d1d5db', margin: '20px 0 16px' }} />
            <section className='studentDetailsModernGroup studentDetailsIdentityIntro'>
                <h2 className='studentDetailsGroupHeading'>Evidence of Identity</h2>
                <p>You must complete the evidence of identity check for this course. Please select one of the below.</p>
            </section>


            <section className='studentDetailsModernGroup'>
                <b className='studentDetailsGroupHeading studentDetailsIdentitySubheading'>Primary (only use one primary document)</b>

                <Dropdown options={['Birth Certificate', 'Australian / International Passport', 'Australian Citizenship Certificate']} value={chosenPrimaryDocument} setValue={setChosenPrimaryDocument} label={'Choose Primary Document'} errorFields={errors} name={'primaryDocument'} />


                {chosenPrimaryDocument && chosenPrimaryDocument.value === 'Birth Certificate' && <>
                    <Input bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('birthCertificate') && errors.length === 1 && errorMessage} errors={errors} name={'birthCertificate'} value={birthCertificate} setValue={setBirthCertificate} label={'Australian Birth Certificate Number (70 points)'} />
                    <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={birthStateIssue} setValue={setBirthStateIssue} label={'State of Issue'} errorFields={errors} name={'birthStateIssue'} />
                </>}


                {chosenPrimaryDocument && chosenPrimaryDocument.value === 'Australian / International Passport' && <>
                    <Input bold type={'text'} errorMessage={errors.includes('passportNumber') && errors.length === 1 && errorMessage} errors={errors} name={'passportNumber'} value={passportNumber} setValue={setPassportNumber} label={'Passport Number (70 points)'} />
                    <Input bold type={'text'} errorMessage={errors.includes('passportCountry') && errors.length === 1 && errorMessage} errors={errors} name={'passportCountry'} value={passportCountry} setValue={setPassportCountry} label={'Country of Issue'} />
                </>}

                {chosenPrimaryDocument && chosenPrimaryDocument.value === 'Australian Citizenship Certificate' && <>
                    <Input bold type={'text'} errorMessage={errors.includes('citizenCert') && errors.length === 1 && errorMessage} errors={errors} name={'citizenCert'} value={citizenCert} setValue={setCitizenCert} label={'Australian Citizenship Certificate Number (70 points)'} />
                </>}


                <b className={`studentDetailsGroupHeading studentDetailsIdentitySubheading studentDetailsSecondaryHeading ${errors.includes('secondaryDoc') ? 'error' : ''}`}>Secondary</b>

                <table className='flip-vertical-table'>

                    <tbody>
                        <tr>
                            <td>Current Australian driver\'s licence or learner driver\'s licence (40 Points)</td>
                            <td style={{ width: '160px' }}>
                                <Input bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('ausLicense') && errors.length === 1 && errorMessage} errors={errors} name={'ausLicense'} value={ausLicense} setValue={setAusLicense} label={'Number'} />
                            </td>
                            <td style={{ width: '120px' }}>
                                <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={ausLicenseStateIssue} setValue={setAusLicenseStateIssue} label={'State of Issue'} errorFields={errors} name={'ausLicenseStateIssue'} />
                            </td>
                        </tr>


                        <tr>
                            <td>Current Australian Boat or PWC Licence (40 Points) </td>
                            <td>
                                <Input bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('boatLicense') && errors.length === 1 && errorMessage} errors={errors} name={'boatLicense'} value={boatLicense} setValue={setBoatLicense} label={'Number'} />
                            </td>
                            <td>
                                <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={boatLicenseStateIssue} setValue={setBoatLicenseStateIssue} label={'State of Issue'} errorFields={errors} name={'boatLicenseStateIssue'} />
                            </td>
                        </tr>

                        <tr>
                            <td>Current NSW Firearms Photo Licence (40 Points) </td>
                            <td>
                                <Input bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('nswPhotoLicense') && errors.length === 1 && errorMessage} errors={errors} name={'nswPhotoLicense'} value={nswPhotoLicense} setValue={setNswPhotoLicense} label={'Number'} />
                            </td>
                            <td>
                            </td>
                        </tr>


                        <tr>
                            <td>Current Australian High Risk Work Licence (40 Points)</td>
                            <td>
                                <Input bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('highRiskLicense') && errors.length === 1 && errorMessage} errors={errors} name={'highRiskLicense'} value={highRiskLicense} setValue={setHighRiskLicense} label={'Number'} />

                            </td>
                            <td>
                                <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={highRiskLicenseState} setValue={setHighRiskLicenseState} label={'State of Issue'} errorFields={errors} name={'highRiskLicenseState'} />
                            </td>
                        </tr>


                        <tr>
                            <td>Current Australian Proof of Age or Photo Card - RMS Issued (40 Points)</td>
                            <td>
                                <Input bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('proofAgeLicense') && errors.length === 1 && errorMessage} errors={errors} name={'proofAgeLicense'} value={proofAgeLicense} setValue={setProofAgeLicense} label={'Number'} />
                            </td>
                            <td>
                                <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={proofAgeLicenseState} setValue={setProofAgeLicenseState} label={'State of Issue'} errorFields={errors} name={'proofAgeLicenseState'} />
                            </td>
                        </tr>

                        <tr>
                            <td>Australian Police or Dept of Defence card with photo (40 Points) </td>
                            <td>
                                <Input bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('policeCard') && errors.length === 1 && errorMessage} errors={errors} name={'policeCard'} value={policeCard} setValue={setPoliceCard} label={'Number'} />

                            </td>
                            <td>
                            </td>
                        </tr>
                    </tbody>
                </table>


                <p style={{ fontWeight: '700', marginTop: '20px' }}>The following documents are worth 25 points.</p>

                <Dropdown options={pointsDocumentOptions} isMulti value={pointsDocuments} setValue={setPointsDocuments} label={'You can select multiple documents'} errorFields={errors} name={'pointsDocuments'} />
                <b className='studentDetailsIdentityNote'>Note: If using credit/savings cards or statements (up to a maximum of 2), these must be from different
                    financial institutions. 1 credit/savings card or statement equates to 25 points, 2 equals 50 points. </b>



            </section>






            <section className='studentDetailsModernGroup'>
            <label className='fieldHeading studentDetailsGroupHeading studentDetailsIdentitySubheading'>Write your full name as it appears on your ID</label>
            <Dropdown options={['Mr', 'Mrs', 'Ms', 'Miss', 'Other']} value={title} setValue={setTitle} label={'Title'} errorFields={errors} name={'title'} />

            <div className='flexrow'>
                <TrainerFieldVerification currentEoi={currentEoi} database={currentEoi.data.trainingType} userData={userData} fieldKey={'firstName'} fieldValue={firstName} onUpdated={handleTrainerVerificationUpdated}>
                    <Input labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('firstName') && errors.length === 1 && errorMessage} errors={errors} name={'firstName'} value={firstName} setValue={setFirstName} label={'First Name'} />
                </TrainerFieldVerification>
                <TrainerFieldVerification currentEoi={currentEoi} database={currentEoi.data.trainingType} userData={userData} fieldKey={'lastName'} fieldValue={lastName} onUpdated={handleTrainerVerificationUpdated}>
                    <Input labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('lastName') && errors.length === 1 && errorMessage} errors={errors} name={'lastName'} value={lastName} setValue={setLastName} label={'Last Name'} />
                </TrainerFieldVerification>
            </div>

            <TrainerFieldVerification currentEoi={currentEoi} database={currentEoi.data.trainingType} userData={userData} fieldKey={'otherName'} fieldValue={otherName} onUpdated={handleTrainerVerificationUpdated}>
                <Input labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('otherName') && errors.length === 1 && errorMessage} errors={errors} name={'otherName'} value={otherName} setValue={setOtherName} label={'Other Name (Middle Name)'} />
            </TrainerFieldVerification>
            </section>


            <section className='studentDetailsModernGroup'>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <label className='fieldHeading studentDetailsGroupHeading' style={{ marginBottom: 0 }}>Residential Address</label>
                <button className='studentDetailsAddressLookup' type='button' onClick={() => setShowResidentialAddressLookup(true)}>Lookup Address</button>
            </div>

            <Input type={'text'} errorMessage={errors.includes('streetNumber') && errors.length === 1 && errorMessage} errors={errors} name={'streetNumber'} value={streetNumber} setValue={setStreetNumber} label={'Unit number/Street number/Property number'} />
            <Input type={'text'} errorMessage={errors.includes('streetName') && errors.length === 1 && errorMessage} errors={errors} name={'streetName'} value={streetName} setValue={setStreetName} label={'Street Name'} />

            <div className='flexrow'>
                <Input type={'text'} errorMessage={errors.includes('suburb') && errors.length === 1 && errorMessage} errors={errors} name={'suburb'} value={suburb} setValue={setSuburb} label={'Suburb'} />
                <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={state} setValue={setState} label={'State'} errorFields={errors} name={'state'} />

            </div>

            <Input type={'text'} errorMessage={errors.includes('postcode') && errors.length === 1 && errorMessage} errors={errors} name={'postcode'} value={postcode} setValue={setPostcode} label={'Postcode'} />




            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <label className='fieldHeading studentDetailsGroupHeading' style={{ marginBottom: 0 }}>Postal Address</label>
                <button className='studentDetailsAddressLookup' type='button' onClick={() => setShowPostalAddressLookup(true)}>Lookup Address</button>
            </div>

            <Checkbox label={'Same as residential address'} value={postalAddressSame} setValue={setPostalAddressSame} />
            <TrainerFieldVerification currentEoi={currentEoi} database={currentEoi.data.trainingType} userData={userData} fieldKey={'streetNumberPostal'} fieldValue={streetNumberPostal} onUpdated={handleTrainerVerificationUpdated}>
                <Input type={'text'} errorMessage={errors.includes('streetNumberPostal') && errors.length === 1 && errorMessage} errors={errors} name={'streetNumberPostal'} value={streetNumberPostal} setValue={setStreetNumberPostal} label={'Unit number/Street number/Property number'} />
            </TrainerFieldVerification>
            <TrainerFieldVerification currentEoi={currentEoi} database={currentEoi.data.trainingType} userData={userData} fieldKey={'streetNamePostal'} fieldValue={streetNamePostal} onUpdated={handleTrainerVerificationUpdated}>
                <Input type={'text'} errorMessage={errors.includes('streetNamePostal') && errors.length === 1 && errorMessage} errors={errors} name={'streetNamePostal'} value={streetNamePostal} setValue={setStreetNamePostal} label={'Street Name'} />
            </TrainerFieldVerification>

            <div className='flexrow'>
                <TrainerFieldVerification currentEoi={currentEoi} database={currentEoi.data.trainingType} userData={userData} fieldKey={'suburbPostal'} fieldValue={suburbPostal} onUpdated={handleTrainerVerificationUpdated}>
                    <Input type={'text'} errorMessage={errors.includes('suburbPostal') && errors.length === 1 && errorMessage} errors={errors} name={'suburbPostal'} value={suburbPostal} setValue={setSuburbPostal} label={'Suburb'} />
                </TrainerFieldVerification>
                <TrainerFieldVerification currentEoi={currentEoi} database={currentEoi.data.trainingType} userData={userData} fieldKey={'statePostal'} fieldValue={statePostal?.value || ''} onUpdated={handleTrainerVerificationUpdated}>
                    <div>
                        <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={statePostal} setValue={setStatePostal} label={'State'} errorFields={errors} name={'statePostal'} />
                    </div>
                </TrainerFieldVerification>
            </div>

            <TrainerFieldVerification currentEoi={currentEoi} database={currentEoi.data.trainingType} userData={userData} fieldKey={'postcodePostal'} fieldValue={postcodePostal} onUpdated={handleTrainerVerificationUpdated}>
                <Input type={'text'} errorMessage={errors.includes('postcodePostal') && errors.length === 1 && errorMessage} errors={errors} name={'postcodePostal'} value={postcodePostal} setValue={setPostcodePostal} label={'Postcode'} />
            </TrainerFieldVerification>
            </section>



            <section className='studentDetailsModernGroup'>
            <div className='flexrow studentDetailsContactRow'>
                <TrainerFieldVerification currentEoi={currentEoi} database={currentEoi.data.trainingType} userData={userData} fieldKey={'dob'} fieldValue={dob} onUpdated={handleTrainerVerificationUpdated}>
                    <Input labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('dob') && errors.length === 1 && errorMessage} errors={errors} placeholder={'DD/MM/YYYY'} name={'dob'} value={dob} setValue={handleDobChange} label={'Date of Birth (dd/mm/yyyy)'} />
                </TrainerFieldVerification>

                <Input labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'tel'} errorMessage={errors.includes('phoneNumber') && errors.length === 1 && errorMessage} errors={errors} name={'phoneNumber'} value={phoneNumber} setValue={setPhoneNumber} label={'Phone Number'} placeholder={'04XXXXXXXX'} />
            </div>

            <TrainerFieldVerification currentEoi={currentEoi} database={currentEoi.data.trainingType} userData={userData} fieldKey={'email'} fieldValue={email} onUpdated={handleTrainerVerificationUpdated}>
                <Input labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} errorMessage={errors.includes('email') && errors.length === 1 && errorMessage} errors={errors} name={'email'} value={email} setValue={setEmail} label={'Email'} />
            </TrainerFieldVerification>
            </section>


            <section className='studentDetailsModernGroup'>
            <h3 className='studentDetailsGroupHeading studentDetailsIdentitySubheading'>Participant Declaration</h3>
            <p> I declare that the details contained on this form are true and correct. The EOI details were provided to the RTO prior to attending TCWT or TCWT assessment under the WHS Regulation.</p>


            {/* <SignatureCanvas penColor='black'
            ref={signatureRef}
            canvasProps={{ width: 500, height: 200, className: `sigCanvas ${errors.includes('signature') ? 'error' : ''}` }} />
        <div>
            <button style={{ color: '#FF7100', background: 'white', border: '1px solid #FF7100' }} onClick={() => signatureRef.current.clear()}>Clear</button>
        </div> */}

            <p>It is an offence under the Crimes Act 1900 (Crimes Act) and WHS Regulation to make false or misleading
                statements in this application.</p>

            <Input bold labelStyle={{ fontSize: '16px', fontWeight: '700' }} type={'text'} placeholder={'DD-MM-YYYY'} errorMessage={errors.includes('declarationDate') && errors.length === 1 && errorMessage} errors={errors} name={'declarationDate'} value={declarationDate} setValue={setDeclarationDate} label={'Date of Declaration'} />
            </section>

            <ModalComponent showModal={!!showDeleteConfirmation} setShowModal={setShowDeleteConfirmation}>
                <> <h2 style={{ textAlign: 'center' }}>Are you sure you want to delete?</h2>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
                        <button disabled={loading} onClick={handleDelete}>{loading ? 'Loading...' : 'Confirm'}</button>
                        <button style={{ marginLeft: '40px', display: 'flex', color: '#FF7100', background: 'white', border: '1px solid #FF7100' }} onClick={() => setShowDeleteConfirmation(false)}>Close</button>
                    </div>
                </>
            </ModalComponent>
            <AddressLookupModal
                showModal={showResidentialAddressLookup}
                setShowModal={setShowResidentialAddressLookup}
                title='Lookup Residential Address'
                initialAddress={address}
                onApply={applyResidentialAddressLookup}
            />
            <AddressLookupModal
                showModal={showPostalAddressLookup}
                setShowModal={setShowPostalAddressLookup}
                title='Lookup Postal Address'
                initialAddress={addressPostal}
                onApply={applyPostalAddressLookup}
            />

            <div style={{ display: hideFooterActions ? 'none' : 'flex', marginBottom: hideFooterActions ? 0 : '60px' }}>
                <button id='nsw-eoi-update-action' disabled={loading} onClick={handleUpdate}>{loading ? 'Loading...' : 'Update'}</button>
                {isAdmin && <button id='nsw-eoi-delete-action' style={{ marginLeft: '40px', display: 'flex', color: '#FF7100', background: 'white', border: '1px solid #FF7100' }} onClick={() => setShowDeleteConfirmation(currentEoi.id)}> Delete</button>}
            </div>
            {isAdmin && <VerificationAuditLog data={currentEoi.data} />}

        </div>
    </div>)
}

export default DisplayTrafficEoi
